import styled from 'styled-components'

const Svg = styled.svg`
  width: 21px;
  height: 21px;
`

export { Svg }
